import { matchPath } from 'react-router';

export const isPathWhiteListed = (whiteList: string[], path: string): boolean => {
  const matchedPaths = whiteList.filter((whiteListedPath) => matchPath(path, whiteListedPath));

  return matchedPaths.length > 0;
};
